import { render, staticRenderFns } from "./CzTabBar.vue?vue&type=template&id=57aca1d0&scoped=true&"
import script from "./CzTabBar.vue?vue&type=script&lang=ts&"
export * from "./CzTabBar.vue?vue&type=script&lang=ts&"
import style0 from "./CzTabBar.vue?vue&type=style&index=0&id=57aca1d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aca1d0",
  null
  
)

export default component.exports